export enum PrintToggle {
    ORDERSUMMARY = 'order-summary-print',
    PACKINGLIST = 'packing-list-print'
}
